import React from 'react'
import AddUserComponent from './addUserComponent'
import Aside from './aside'
import TopBar from './topBar'

const AddUser = () => {
  return (
    <div className="main-wrapper">
      <div className="content-wrapper">
        <AddUserComponent />
      </div>
    </div>
  )
}

export default AddUser